import React, { useState } from 'react';
import axios from 'axios';
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { MessageCircle, X, Send } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ChatPopup = ({ ticketNumber = null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    client_name: '',
    client_phone: '',
    message: '',
    ticket_number: ticketNumber || ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.client_name || !formData.client_phone || !formData.message) {
      toast.error('ju lutem plotësoni të gjitha fushat e detyrueshme');
      return;
    }

    setLoading(true);
    
    try {
      await axios.post(`${API}/chat/messages`, {
        client_name: formData.client_name,
        client_phone: formData.client_phone,
        message: formData.message,
        ticket_number: formData.ticket_number || null
      });
      
      toast.success('Mesazhi u dërgua me sukses! Do t\'iu përgjigjemi së shpejti.');
      
      // Reset form
      setFormData({
        client_name: '',
        client_phone: '',
        message: '',
        ticket_number: ticketNumber || ''
      });
      setIsOpen(false);
    } catch (error) {
      toast.error('Gabim në dërgimin e mesazhit. Provoni përsëri.');
      console.error('Chat message error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Chat Bubble Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className="w-16 h-16 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg flex items-center justify-center"
        >
          {isOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
        </Button>
      </div>

      {/* Chat Popup */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 z-50">
          <Card className="shadow-xl">
            <CardHeader className="bg-blue-600 text-white rounded-t-lg">
              <CardTitle className="text-lg flex items-center">
                <MessageCircle className="w-5 h-5 mr-2" />
                Kontaktoni me ne
              </CardTitle>
              <CardDescription className="text-blue-100">
                Dërgoni një mesazh dhe do t'iu përgjigjemi së shpejti
              </CardDescription>
            </CardHeader>
            
            <CardContent className="p-4">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label htmlFor="client_name">Emri juaj *</Label>
                  <Input
                    id="client_name"
                    value={formData.client_name}
                    onChange={(e) => setFormData(prev => ({ ...prev, client_name: e.target.value }))}
                    placeholder="Emri dhe mbiemri"
                    required
                  />
                </div>

                <div>
                  <Label htmlFor="client_phone">Telefoni *</Label>
                  <Input
                    id="client_phone"
                    value={formData.client_phone}
                    onChange={(e) => setFormData(prev => ({ ...prev, client_phone: e.target.value }))}
                    placeholder="069 123 4567"
                    required
                  />
                </div>

                {!ticketNumber && (
                  <div>
                    <Label htmlFor="ticket_number">Numri i Tiketës (Opsional)</Label>
                    <Input
                      id="ticket_number"
                      value={formData.ticket_number}
                      onChange={(e) => setFormData(prev => ({ ...prev, ticket_number: e.target.value }))}
                      placeholder="p.sh. IT1209251"
                    />
                  </div>
                )}

                <div>
                  <Label htmlFor="message">Mesazhi *</Label>
                  <Textarea
                    id="message"
                    value={formData.message}
                    onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))}
                    placeholder="Shkruani mesazhin tuaj këtu..."
                    rows={4}
                    required
                  />
                </div>

                <div className="flex space-x-2">
                  <Button
                    type="submit"
                    disabled={loading}
                    className="flex-1"
                  >
                    {loading ? (
                      'Duke dërguar...'
                    ) : (
                      <>
                        <Send className="w-4 h-4 mr-2" />
                        Dërgo
                      </>
                    )}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => setIsOpen(false)}
                  >
                    Mbyll
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};

export default ChatPopup;